export default {
    leads: [
        {
            id: 0,
            fullname: "Srinjoy Santra",
            role: "Founder and Lead Developer",
            description: "He is a socially awkward, sometimes-funny, software developer who lead vain efforts to reconnect with his schoolmates through this project.",
            profileImg: 'https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/srinjoy-santra.jpg',
        },
        {
            id: 1,
            fullname: "Rajyasree Sarkar",
            role: "Lead Designer",
            description: "She is a digital arts wizard who loves playing with her pets.",
            profileImg: 'https://storage.googleapis.com/yearbookofdolna.appspot.com/classmates/rajyasree-sarkar.jpg',
        },
        /* {
            id: 2,
            fullname: "T.J. Detweiler",
            role: "Lead Content Creator",
            description: " He is outgoing, kindhearted, and friendly, and takes having fun very seriously. He also appears to have a good sense of honor.",
            profileImg: 'https://source.unsplash.com/Vnm4aweBwPA/270X270',
        }, */
    ],
    teams: [
        /* {
            name: "Web Dev Team",
            members: [
                {
                    id: 0,
                    fullname: 'Ashley Spinelli',
                    profileImg: 'https://source.unsplash.com/xe68QiMaDrQ/135X135/'
                },
                {
                    id: 1,
                    fullname: 'Vincent Pierre Lacelle',
                    profileImg: 'https://source.unsplash.com/FBipORWOxSo/135X135/'
                },
                {
                    id: 2,
                    fullname: 'Gretchen Grundler',
                    profileImg: 'https://source.unsplash.com/15k5fhn_Je8/135X135/'
                },
                {
                    id: 3,
                    fullname: 'Michael Blumberg',
                    profileImg: 'https://source.unsplash.com/37i9q9REXs0/135X135/'
                },
                
            ]
        },
        {
            name: "Design Team",
            members: [
                {
                    id: 0,
                    fullname: 'Michael Blumberg',
                    profileImg: 'https://source.unsplash.com/37i9q9REXs0/135X135/'
                },
                {
                    id: 1,
                    fullname: 'Vincent Pierre Lacelle',
                    profileImg: 'https://source.unsplash.com/FBipORWOxSo/135X135/'
                },
                {
                    id: 2,
                    fullname: 'Gretchen Grundler',
                    profileImg: 'https://source.unsplash.com/15k5fhn_Je8/135X135/'
                },
            ]
        }, */
        {
            name: "Content Team",
            members: [
                {
                    id: 0,
                    fullname: 'Senjuti Kumar',
                    profileImg: 'https://source.unsplash.com/tNCH0sKSZbA/135X135/'
                },
                {
                    id: 1,
                    fullname: 'Subhechcha Sadhu',
                    profileImg: 'https://source.unsplash.com/JHyAiRMi5Fk/135X135/'
                },
                {
                    id: 2,
                    fullname: 'Mohana Deb',
                    profileImg: 'https://source.unsplash.com/15k5fhn_Je8/135X135/'
                },
                {
                    id: 3,
                    fullname: 'Ahona Rudra',
                    profileImg: 'https://source.unsplash.com/0wRXAXqIp58/135X135/'
                },
                {
                    id: 4,
                    fullname: 'Dyuti Roy',
                    profileImg: 'https://source.unsplash.com/ff5K3-kYPHA/135X135/'
                },
            ]
        }
    ]
    
}


// WEBPACK FOOTER //
// ./src/data/credits.js